// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608170343/js/" + chunkId + "." + {"44":"6b67fa76","225":"7dd00eea","481":"8eb80716","486":"cef2f588","770":"228a2d4a"}[chunkId] + ".0.5886399022205812.chunk.js";
};